/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Cost_Privacy_NoteInputs */



/**
* | output |
* | --- |
* | "Only your own usage is shown." |
*
* @param {Chat_Cost_Privacy_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_cost_privacy_note = /** @type {((inputs?: Chat_Cost_Privacy_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Cost_Privacy_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wird nur deine eigene Nutzung angezeigt.")
	return /** @type {LocalizedString} */ ("Only your own usage is shown.")
});